<template>
    <div>
        <v-btn v-if="showGoToTemplates" color="accent" icon @click="showListEvaluations">
            <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn color="secondary" icon @click="showAddTemplate">
            <v-icon>mdi-plus</v-icon>
        </v-btn>

        <create-evaluation-dialog ref="evaluation" />
        <evaluations-list-dialog ref="list" />
    </div>
</template>

<script>
import CreateEvaluationDialog from "@/components/coach/CreateEvaluationDialog";
import EvaluationsListDialog from '../../coach/EvaluationsListDialog.vue';
export default {
    name: "ManageEvaluations",
    components: { CreateEvaluationDialog, EvaluationsListDialog },
    computed: {
        showGoToTemplates(vm = this) {
            return vm.$route.name !== 'coach.evaluations.list'
        }
    },
    methods: {
        showAddTemplate() {
            const vm = this
            vm.$refs.evaluation.show()
        },
        showListEvaluations() {
            const vm = this
            vm.$refs.list.show()
        }
    }
}
</script>

<style scoped></style>